module.exports = __webpack_public_path__ + "1340f1b7a1e844fe41ade67c838fa52e.svg";